// navigation.ts
let navigateFn;

export const setNavigate = (fn) => {
  navigateFn = fn;
};

export const navigateOutsideComponent = (path) => {
  if (navigateFn) {
    navigateFn(path);
  } else {
    window.location.href = "/login";
  }
};
